module.exports=function(scope){ return `private final static String encryptionKey = loadResourceString("privateKey.pem");
zoomInstance = ZoomAuthentication.initialize(deviceLicenseKeyIdentifier, serverLicenseKey, encryptionKey);`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/encryption-keys.java.tpl